export type ThemeMode = 'light' | 'dark' | 'system';
export type ResolvedTheme = 'light' | 'dark';
export type ThemeVariant = 'default' | 'neon';

export const THEME_STORAGE_KEY = 'theme-mode';
export const THEME_VARIANT_STORAGE_KEY = 'theme-variant';

export function resolveTheme(mode: ThemeMode): ResolvedTheme {
  if (mode === 'light') return 'light';
  if (mode === 'dark') return 'dark';
  return window.matchMedia('(prefers-color-scheme: dark)').matches
    ? 'dark'
    : 'light';
}

export function applyTheme(resolved: ResolvedTheme): void {
  const el = document.documentElement;
  if (resolved === 'dark') {
    el.classList.add('dark');
  } else {
    el.classList.remove('dark');
  }
}

export function applyThemeVariant(variant: ThemeVariant): void {
  const el = document.documentElement;
  if (variant === 'neon') {
    el.classList.add('theme-neon');
  } else {
    el.classList.remove('theme-neon');
  }
}

export function getStoredThemeMode(): ThemeMode {
  const stored = localStorage.getItem(THEME_STORAGE_KEY);
  if (stored === 'light' || stored === 'dark' || stored === 'system') {
    return stored;
  }
  return 'dark';
}

export function storeThemeMode(mode: ThemeMode): void {
  localStorage.setItem(THEME_STORAGE_KEY, mode);
}

export function getStoredThemeVariant(): ThemeVariant {
  const stored = localStorage.getItem(THEME_VARIANT_STORAGE_KEY);
  if (stored === 'neon') return 'neon';
  return 'default';
}

export function storeThemeVariant(variant: ThemeVariant): void {
  localStorage.setItem(THEME_VARIANT_STORAGE_KEY, variant);
}
